/**
 * Toolpad entry point kept for `dialogs.open(EditUser, { user })` callers
 * (EditUserButton on the user details page). The list's row actions render
 * UserFormDialog directly.
 */
import type { IUser } from "@/api";
import { UserFormDialog } from "@/components/admin/dialogs/new-user-dialog/UserFormDialog";
import type { DialogProps } from "@toolpad/core/useDialogs";

interface IProps {
    user: IUser;
}

export const EditUser = ({ open, onClose, payload }: DialogProps<IProps>) => (
    <UserFormDialog
        open={open}
        onOpenChange={(next) => {
            if (!next) onClose();
        }}
        user={payload.user}
    />
);

export default EditUser;
